const deleteAddDocumentServices = {
  toastr: 'Documento deletado',
  toastr1: 'O documento foi deletado com sucesso'
};

export default deleteAddDocumentServices;
